<template>
  <div id="footer" class="container-fluid" v-if="!$route.meta.hideBottom">
    <div class="shareIcons shareTypes">
      <div>
        <div v-for="(item,k) in content" :key="k" class="infolist">
          <img
            :src="'https://files.ijinzheng.com/ijinzheng/foundation/index/'+item.name+'.png'"
            alt
          >
          <span v-if="k!=3">{{item.value}}</span>
          <a
            :href="item.value"
            v-else
            style="text-decoration:none;color:#000;;"
            target="_blank"
          >{{item.value}}</a>
        </div>
      </div>
      <div class="bigimg">
        <p>
          {{$t("footer.product")}}
        </p>
        <ul>
          <li>{{$t("footer.product1")}}</li>
          <li>{{$t("footer.product2")}}</li>
          <li>{{$t("footer.product3")}}</li>
        </ul>
        <!-- <img src="https://files.ijinzheng.com/ijinzheng/foundation/index/ewm2.jpg" alt> -->
      </div>
    </div>
    <p class="copy">{{$t("footer.copyRight")}} © 2024{{$t("commen.companyName")}} | <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">{{$t("footer.copyRight2")}}</a></p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      content: [
        {
          name: "phone",
          value: this.$t("footer.phone")
        },
        {
          name: "position",
          value: this.$t("footer.address")
        },
        {
          name: "email",
          value: this.$t("footer.email")
        }
      ]
    };
  },
  methods: {}
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  border-top: 6px solid #f18700;
  color: #000;
  background: #fff;
  margin: 0px;
  overflow: hidden;
  text-align: center;
  padding: 0px;
  
}

.shareTypes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 60%;
  margin-left: 20%;
}

.bigimg {
  margin-right: 20px;
  margin-top: 20px;
  color: #000;
  width: 30% !important;
  
}
.bigimg  p{
  font-size: 14px;
  color: #000;
  width: 50%;
  margin-bottom:20px;
  text-align: left;
}
.bigimg ul{
  width: 50%;
}
.bigimg  li{
    text-align: left;
  margin-bottom: 15px;
  font-size: 12px;
  font-weight: 700;
}
.bigimg img {
  display: inline-block;
}
.infolist {
  color: #000;;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 12px;
}
.shareIcons .infolist img {
  width: 20px;
  margin-right: 10px;
}
.shareIcons > div {
  width: 50%;
}
.shareIcons img {
  width: 132px;
  text-align: center;
}

.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 20px 0 10px;
  color: #000;;
  padding-top: 20px;
  text-align: left;
  margin-left: 20%;
}
.copy a{
    color: #000;;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  #footer{
    border-top: 1px solid #eee;
  }
  .infolist{
    padding:0 10px;
  }

  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
  margin: 10px 0 10px;
    padding-top: 0px;
    text-align: center;
    
  }
   .copy a{
   }
  .shareIcons {
    display: block;
    width: 100%;
    margin-left: 0%;
  }
  .shareIcons > div{
    width: 100% !important;
  }
  .shareIcons > div:first-child{
    display: none;
  }
  .shareIcons div.bigimg {
    width: 100% !important;
    text-align: center;
  }
  .bigimg ul,div.bigimg p{
    width: 100%
  }
   div.bigimg p,div.bigimg ul li{
      text-align: center;
      display: none;
   }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue